import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang, copy } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export default function Chapters() {
  const { lang } = useLang();
  const chapters = copy[lang].chapters;
  const [open, setOpen] = useState(-1);

  const paras = (ch, i) =>
    ch.paras.map((p, j) => (
      <p
        key={j}
        data-testid={`chapter-${i}-para-${j}`}
        className="text-lg md:text-xl font-light leading-loose text-white"
      >
        {p}
      </p>
    ));

  return (
    <section
      id="torque"
      data-testid="chapters-section"
      className="border-t px-6 md:px-14 py-[12vh] space-y-[10vh] text-center"
      style={{ borderColor: "var(--line-soft)" }}
    >
      {chapters.map((ch, i) => {
        const collapsible = i > 0;
        const isOpen = open === i;
        return (
          <Reveal key={i}>
            <article
              data-testid={`chapter-${i}`}
              className="max-w-2xl mx-auto space-y-6"
            >
              <span className="block font-mono-fmf text-[15px] tracking-[0.5em] text-[var(--dim)]">
                {String(i + 1).padStart(2, "0")}
              </span>
              {ch.title &&
                (collapsible ? (
                  <button
                    data-testid={`chapter-${i}-toggle`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="font-mono-fmf font-light text-xl md:text-2xl uppercase tracking-[0.2em] fmf-gold-text cursor-pointer transition-opacity duration-700 hover:opacity-60"
                  >
                    {ch.title}
                  </button>
                ) : (
                  <h2 className="font-mono-fmf font-light text-xl md:text-2xl uppercase tracking-[0.2em] fmf-gold-text">
                    {ch.title}
                  </h2>
                ))}
              {collapsible ? (
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <div className="space-y-6 pt-2">{paras(ch, i)}</div>
                    </motion.div>
                  )}
                </AnimatePresence>
              ) : (
                paras(ch, i)
              )}
            </article>
          </Reveal>
        );
      })}
    </section>
  );
}
